import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import PurchaseOrderGrid from "presentation/components/PurchaseOrder/PurchaseOrderGrid";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";

const PurchaseOrderGridPage = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const { isLoading } = usePermissionCheck({
    requiredFunction: "purchaseOrders",
  });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Ordens de Compra" />
      <PurchaseOrderGrid />
    </div>
  );
};

export default PurchaseOrderGridPage;
